"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssigneePerformanceSerializer = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
class AssigneePerformanceSerializer extends dp_http_client_lib_1.PageableSerializer {
    constructor(itemPerformanceSerializer, itemQuestionPerformanceSerializer) {
        super();
        this.itemPerformanceSerializer = itemPerformanceSerializer;
        this.itemQuestionPerformanceSerializer = itemQuestionPerformanceSerializer;
    }
    serializeOne(data) {
        return {
            maxScore: data.maxScore,
            score: data.score,
            averageScore: data.averageScore,
            assessmentId: data.assessmentId,
            assessmentTemplateId: data.assessmentTemplateId,
            contextId: data.contextId,
            assigneeId: data.assigneeId,
            itemsPerformance: (data.itemsPerformance || []).map((performance) => this.itemPerformanceSerializer.serializeOne(performance)),
            itemQuestionsPerformance: (data.itemQuestionsPerformance || []).map((performance) => this.itemQuestionPerformanceSerializer.serializeOne(performance)),
        };
    }
}
exports.AssigneePerformanceSerializer = AssigneePerformanceSerializer;
//# sourceMappingURL=assignee-performance.serializer.js.map